export default __webpack_public_path__ + "static/media/creepysfx.16304b81.wav";